import React, { forwardRef } from "react";
import gsap from "gsap";

export const Label = ({ children, className }) => {
  return (
    <span className={`text-white text-[22px] leading-tight font-light center block max-w-[340px] m-auto ${className}`}>
      {children}
    </span>
  );
}
export const PageContainer = ({ children, id, className}) => {
  return (
    <div id={id} className={`${className} w-full min-h-full flex align-middle justify-center`}>
      {children}
    </div>
  );
}

export const Callout = forwardRef(({ children, className, onClick, border = false, href }, ref) => {
    if (href) {
        return (
          <a href={href} onClick={onClick}>
            <div ref={ref} className={`${className} flex flex-row !flex-col items-center relative mobile:mx-4 md:w-[440px] m-auto z-10 ${border ? "bg-black bg-opacity-80 shadow-callout border-2 border-white p-4" : "py-4 px-12"} rounded-md text-center leading-tight text-[18px]`}>
                {children}      
            </div>
          </a>
        );
    }
    return (
      <div ref={ref} onClick={onClick} className={`${className} flex flex-row md:flex-col items-center relative mobile:mx-4 md:w-[440px] m-auto z-10 ${border ? "bg-black bg-opacity-80 shadow-callout border-2 border-white p-4" : "py-4 px-12"} rounded-md text-center leading-tight text-[18px]`}>
        {children}      
      </div>
    );
});

export const CalloutCopyEndFrame = ({ children, className }) => {
  return (
    <p className="text-center text-[22px] text-white md:text-center  m-auto mb-0 md:pt-3 md:pb-2">
      {children}      
    </p>
  );
}

export const CrossFade = (el1, el2, speed=.5) => {
  // gsap.set(el1, {opacity: 0});
  // gsap.set(el2, {opacity: 1});
  gsap.to(el1, {opacity: 0, duration: speed, ease:"power2.out"});
  gsap.to(el2, {opacity: 1, duration: speed, ease:"power2.out"});
}